import React from 'react'
import { Link } from "react-router-dom";

const GeneratePCFList = (arrData) => {
    var results = [];
    results = arrData.map((v) => {
        var obj = {};
        obj.action_type = (v.action_type === "asc.course.action.add") ? "add" : "remove";
        obj.origin = true;
        obj.course_id = v.course_id;
        obj.section_id = v.section_id;
        v.course_code = v.code;
        v.course_credit = v.credit;
        let type = "";
        if (v.course_type) {
            let typeArr = v.course_type.split(".");
            type = typeArr[typeArr.length - 1];
        }
        v.course_type = type;
        obj.detail = v;
        return obj;
    })
    return results;
}
const StudentEventStatus = ({ data }) => {
    return (
        <div>
            <div className="d-flex justify-content-start align-items-center">
                <Link
                    className="btn btn-clear btn-sm text-hover-warning"
                    to={"/counseling/student/" + data.studentid + "/activity"}
                >
                    <i className="fa fa-arrow-left"></i>
                </Link>
                <div className="title border-left pl-5">
                    <h3 className="mb-0">Form PCF Approval</h3>
                </div>
            </div>

            <div className="submited-info mt-5 ">
                <div className="row">
                    <div className="col-auto">
                        <div className="form-group">
                            <label>Academic Term</label>
                            <div className="font-weight-bold h4">{data?.atp_term?.name}</div>
                        </div>
                    </div>
                    <div className="col-auto">
                        <div className="form-group">
                            <label>Activity {data?.student_activity?.name}</label>
                            <div className={"font-weight-bold h4 " + (data.status && data.status === "PROCESSED" ? "text-success" : "text-warning")}>
                                {data?.status_activity || data?.status}
                            </div>
                        </div>
                    </div>
                    <div className="col-auto">
                        <div className="form-group">
                            <label>Submited Date</label>
                            <div className="font-weight-bold h4">{data?.submit_date_formatted}</div>
                        </div>
                    </div>
                    {data.approve_date_formatted && (
                        <div className="col-auto">
                            <div className="form-group">
                                <label>Approved Date</label>
                                <div className="font-weight-bold h4">{data?.approve_date_formatted}</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export { GeneratePCFList, StudentEventStatus }